export default __webpack_public_path__ + "static/media/Hourglass.b03858ca.svg";